"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataQualityScreen = void 0;
const plugin_html_multi_response_1 = __importDefault(require("@jspsych-contrib/plugin-html-multi-response"));
const taskSetup_1 = require("../../taskSetup");
const taskStore_1 = require("../../../taskStore");
const finishExperiment_1 = require("./finishExperiment");
const t = (0, taskStore_1.taskStore)().translations;
const buttonText = ['dataQuestionnaireButtonText1', 'dataQuestionnaireButtonText2', 'dataQuestionnaireButtonText3'];
exports.dataQualityScreen = {
    type: plugin_html_multi_response_1.default,
    data: () => {
        return {
            // save_trial: true,
            assessment_stage: 'assessor_questionaire',
        };
    },
    stimulus: `<div class="lev-row-container header">
        <p>Assessor Data Questionnaire</p>
      </div>
      <div class="lev-row-container instruction">
        <p>How would you rate the quality of the data for this task?</p>
      </div>
      <footer style="text-align: center; margin: 20px 0;">
        Note: This is NOT a question about how well the child performed. Instead, we want your impression of how well the child understood and actively participated in the task.
      </footer>`,
    keyboard_choices: 'NO_KEYS',
    button_choices: () => buttonText,
    button_html: () => {
        const t = (0, taskStore_1.taskStore)().translations;
        return buttonText.map((text) => `<button class="primary" style="font-size: 16px">${t[text]}</button>`);
    },
    on_load: () => {
        const jsPsychContent = document.getElementsByClassName('jspsych-content')[0];
        jsPsychContent.setAttribute('style', 'width: 80vw; max-width: 800px; padding: 20px; background-color: white');
        const buttonContainer = document.getElementById('jspsych-html-multi-response-btngroup');
        buttonContainer.classList.add('lev-response-row', 'multi-stack');
    },
    on_finish: (data) => {
        let dataQuality = '';
        if (data.button_response === 0) {
            dataQuality = 'SERIOUS CONCERNS';
        }
        else if (data.button_response === 1) {
            dataQuality = 'OK';
        }
        else if (data.button_response === 2) {
            dataQuality = 'GOOD';
        }
        taskSetup_1.jsPsych.data.addDataToLastTrial({
            dataQuality: dataQuality,
        });
        const jsPsychContent = document.getElementsByClassName('jspsych-content')[0];
        jsPsychContent.setAttribute('style', ''); // remove styling from jspsych-content for next trial
        (0, finishExperiment_1.finishExperiment)();
    },
};
